import { useQuery } from '@apollo/client';
import { useClearAccount, useCurrentAccount } from '@application/api';
import { useRouter } from '@application/utils';
import { graphql } from '@gql/gql';
import type {
  BookingListGetBookingsQuery,
  BookingListGetBookingsQueryVariables,
} from '@gql/graphql';
import { SortOrder } from '@gql/graphql';
import { useMemo } from 'react';

export const BOOKING_LIST_GET_BOOKINGS = graphql(`
  query BookingListGetBookings(
    $bookingsOrderBy: BookingOrderByWithRelationAndSearchRelevanceInput
    $bookingCardInfoProTranslationsWhere: ProTranslationWhereInput!
    $bookingCardInfoServiceTranslationsWhere: ServiceTranslationWhereInput!
  ) {
    accountMe {
      id
      bookings(orderBy: $bookingsOrderBy) {
        ...BookingCardInfo
      }
    }
  }
`);

export const useGetBookings = () => {
  const { language } = useRouter();
  const { currentAccount } = useCurrentAccount();
  const { redirectOnTokenErrorHandler } = useClearAccount();

  const variables = useMemo((): BookingListGetBookingsQueryVariables => {
    return {
      bookingsOrderBy: { startDateTime: SortOrder.desc },
      bookingCardInfoProTranslationsWhere: { language: { equals: language } },
      bookingCardInfoServiceTranslationsWhere: { language: { equals: language } },
    };
  }, [language]);

  const { data, error, loading } = useQuery<
    BookingListGetBookingsQuery,
    BookingListGetBookingsQueryVariables
  >(BOOKING_LIST_GET_BOOKINGS, {
    variables,
    onError: redirectOnTokenErrorHandler,
    ssr: false,
    skip: !currentAccount,
    fetchPolicy: 'cache-and-network',
  });

  return {
    bookings: data?.accountMe?.bookings ?? [],
    bookingsError: error,
    bookingsLoading: loading,
  };
};
